import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserBasicInfo } from '../../modules/buildings-shared/model/user-basic-info';
import { PermissionService } from '../../modules/buildings-shared/services/permission.service';
import { LoginComponent } from "../login/login.component";
import { EncodeErrorInfo } from '../../modules/buildings-shared/model/encode-error-info';
import { AccountInfo } from '../../modules/buildings-shared/model/account-info';

@Component({
  selector: 'app-account-activate',
  imports: [LoginComponent],
  templateUrl: './account-activate.component.html',
  styleUrl: './account-activate.component.scss'
})
export class AccountActivateComponent implements OnInit {

    private token: string | undefined;
    private emailActivated: boolean | undefined;
    private accountInfo: AccountInfo | undefined;

    constructor(private readonly router: Router, private readonly permissionService: PermissionService,
        private readonly activatedRoute: ActivatedRoute) {}
    
    ngOnInit(): void {
        /*****************************
        this.permissionService.alert("Modal Standard Hello World").then( (data: boolean) => {
            console.log("MODAL CLOSED ... RESULT: " + data);
        });
        ******************************/
       this.permissionService.setWaitingSpinner(true);
        this.activatedRoute.queryParams.subscribe ( (params: Params) => {
            if (params && params["token"] && params["token"].length > 0) {
                this.token = decodeURIComponent(params["token"]);
                this.permissionService.activateAccount(this.token ?? "").then((accountInfo: AccountInfo) => {
                    this.accountInfo = accountInfo;
                    if(this.accountInfo) {
                        this.permissionService.setWaitingSpinner(false);
                        this.permissionService.alert("Ciao " + (this.accountInfo.nickname ?? "") + "! Il tuo account è stato attivato. Esegui il login per accedere al servizio").then( (data: boolean) => {
                            console.log("MODAL CLOSED ... RESULT: " + data);
                            this.router.navigate(['/login'], { queryParams: { emailActivated: true } });
                        });
                    }
                }).catch( async (error: any) => {
                    const returnedError: EncodeErrorInfo = error.error;
                    console.error("AccountActivateComponent.ngOnInit() - an error occurred. EROR CODE: " + (returnedError.code ?? (error.code ?? error.message) ) );
                    let modalMessage: string;
                    switch(returnedError.code) {
                        case "email_token_not_found": {
                            modalMessage = "La richiesta di attivazione del nuovo account non è più valida. Esegui nuovamente la registrazione.";
                            break;
                        }
                        case "email_token_expired": {
                            modalMessage = "La richiesta di attivazione del nuovo account è scaduta: esegui nuovamente la registrazione.";
                            break;
                        }
                        case "user_not_found": {
                            modalMessage = "L'utente da attivare non è stato trovato: esegui nuovamente la registrazione.";
                            break;
                        }
                        default: {
                            modalMessage = "Si è verificato un problema durante l'attivazione del nuovo utente: riprova più tardi.";
                        }
                    }
                    this.permissionService.setWaitingSpinner(false);
                    this.permissionService.alert(modalMessage).then( (data: boolean) => {
                        console.log("MODAL CLOSED ... RESULT: " + data);
                        this.router.navigateByUrl("login");
                    });
                });
            } else {
                this.permissionService.setWaitingSpinner(false);
                this.permissionService.alert("La richiesta di attivazione del nuovo account non è valida. Esegui nuovamente la registrazione oppure contatta l'assistenza.").then( (data: boolean) => {
                    console.log("MODAL CLOSED ... RESULT: " + data);
                    this.router.navigateByUrl("login");
                });
            }
        });
    }
}
